// extracted by mini-css-extract-plugin
module.exports = {"searchError":"SearchError_searchError__UkJPS","searchErrorTitle":"SearchError_searchErrorTitle__fRtZg","searchErrorText":"SearchError_searchErrorText__mkq_K"};